import { render, staticRenderFns } from "./active-card.vue?vue&type=template&id=79eaf54a&scoped=true"
import script from "./active-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./active-card.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eaf54a",
  null
  
)

export default component.exports